import React, { useContext, useState, useEffect, useRef } from 'react';
import { faSignOutAlt, faCog, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import './header.css';
import { useAuth } from '../AuthContext'; // ✅ context
import { redirectToLogin } from '../utils/authRedirect';

const apiUrl = process.env.REACT_APP_API_URL;

const UserMenu = () => {
  const [userMenu, setUserMenu] = useState(false);
  const [profilePicture, setProfilePicture] = useState('');
  const menuRef = useRef(null);
  const imageRef = useRef(null);
  const { user, setUser, loading } = useAuth(); // ✅

  const handleLogout = async () => {
    try {
      await fetch(`${apiUrl}/logout`, {
        method: 'POST',
        credentials: 'include',
      });
      setUser(null);        // ✅ șterge utilizatorul din context
      redirectToLogin();
    } catch (err) {
      console.error('Logout error:', err);
    }
  };

  const handleUserMenu = () => {
    setUserMenu(!userMenu);
  };

  const closeMenuUser = () => {
    setUserMenu(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        imageRef.current &&
        !imageRef.current.contains(event.target)
      ) {
        setUserMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [userMenu]);

  useEffect(() => {
    if (!user) return;
    
    fetch(`${apiUrl}/user`, {
      method: 'GET',
      credentials: 'include',
    })
      .then((response) => response.ok ? response.json() : Promise.reject('Failed to fetch user data'))
      .then((data) => {
        setProfilePicture(data.profile_picture || '');
      })
      .catch((error) => {
        console.error('Error fetching user data:', error);
      });
  }, [user]);

  // Nu afișa nimic dacă se verifică autentificarea sau utilizatorul nu este autentificat
  if (loading || !user) {
    return null;
  }

  return (
    <div className='container-user-menu'>
      <div ref={menuRef} className={userMenu ? 'menu-user-icon' : 'menu-user-icon-hide'}>
        <Link to='./userpage'>
          <button onClick={closeMenuUser} className='item-user-menu-icon'>
            <FontAwesomeIcon icon={faUser} /> Profilul meu
          </button>
        </Link>
        <Link to='./setari'>
          <button onClick={closeMenuUser} className='item-user-menu-icon'>
            <FontAwesomeIcon icon={faCog} /> Setari
          </button>
        </Link>
        <Link to='./ajutor'>
          <button onClick={closeMenuUser} className='item-user-menu-icon'>
            <FontAwesomeIcon icon={faQuestionCircle} /> Ajutor
          </button>
        </Link>
        <button onClick={() => { handleLogout(); closeMenuUser(); }} className='item-user-menu-icon'>
          <FontAwesomeIcon icon={faSignOutAlt} className="mx-1" />
          Logout
        </button>
      </div>
    </div>
  );
};

export default UserMenu;
